import type { MutableRefObject } from 'react';

import { PsyToolsId } from '../../../../components/meet/tools-panel/types';
import { setActiveTool } from '../../../../store/meetActiveTool.slice';
import {
  clearMacClientSelections,
  clearMacSharedView,
  setMacClientSelection,
  setMacDec,
  setMacSelected,
  setMacSharedView,
} from '../../../../store/mac.slice';
import type { MeetOverlaysBridgeApi } from '../../MeetOverlaysProvider';

export interface MacCardsOpenPayload {
  show: boolean;
  cover: string;
  color: string;
  result: { name: string; value: string[] };
}

export interface MacCardSelectionItem {
  id: number;
  img: string;
  selected: boolean;
}

export interface MacRoomHandlersArgs {
  isPsychologist: boolean;
  isGroupConsultationFlag: boolean;
  dispatch: (action: unknown) => void;
  overlaysApiRef: MutableRefObject<MeetOverlaysBridgeApi | null>;
}

export interface MacRoomHandlers {
  onMacCardsOpen: (data: MacCardsOpenPayload) => void;
  onClientMacSelection?: (from: string, cards: MacCardSelectionItem[]) => void;
  onMacCardsClose?: () => void;
  onMacSharedView?: (label: string, cards: MacCardSelectionItem[]) => void;
}

export function createMacRoomHandlers({
  isPsychologist,
  isGroupConsultationFlag,
  dispatch,
  overlaysApiRef,
}: MacRoomHandlersArgs): MacRoomHandlers {
  return {
    onMacCardsOpen: (data: MacCardsOpenPayload) => {
      if (!isPsychologist) {
        overlaysApiRef.current?.setShowModalInstruct(
          window.innerHeight > window.innerWidth
            ? 'Психолог активировал инструмент "Метафорические карты". Пожалуйста, НЕ переворачивайте экран телефона в горизонтальное положение'
            : 'Психолог включил инструмент «Метафорические карты».',
        );

        const deck = (data.result?.value ?? [])
          .filter((_: string, index: number) => index !== 0)
          .map((img: string, index: number) => ({
            id: index + 1,
            img,
            selected: false,
            show: data.show,
            deck: data.result?.name || '',
            deckCover: data.cover || '',
            deckColor: data.color || '',
          }));

        // При каждом новом открытии колоды сбрасываем прошлый выбор клиента,
        // чтобы не показывать устаревшие карты от предыдущего раунда.
        dispatch(setMacSelected([]));
        dispatch(setMacDec(deck));
        dispatch(setActiveTool(PsyToolsId.MAC_CARDS));
      }
    },

    onClientMacSelection:
      isPsychologist
        ? (from: string, cards: MacCardSelectionItem[]) => {
            if (isGroupConsultationFlag) {
              dispatch(setMacClientSelection({ participantIdentity: from, cards }));
              return;
            }

            dispatch(setMacSelected(cards));
          }
        : undefined,

    onMacCardsClose:
      !isPsychologist
        ? () => {
            dispatch(setActiveTool(0));

          if (isGroupConsultationFlag) {
            dispatch(clearMacClientSelections());
            dispatch(clearMacSharedView());
          }

          dispatch(setMacDec([]));
          dispatch(setMacSelected([]));
          }
        : undefined,

    onMacSharedView:
      !isPsychologist && isGroupConsultationFlag
        ? (label: string, cards: MacCardSelectionItem[]) => {
            dispatch(setMacSharedView({ participantLabel: label, cards }));
          }
        : undefined,
  };
}

